module.exports = __webpack_public_path__ + "img/logo.510f7020.png";